import { api } from '@http/constants';
import fetchWrapper from '@/http/fetchWrapper';
import { userAtom } from '@/global-store';
import type { RegeneratedApiKey } from '@eye-able/types';
import { useMutation } from '@tanstack/react-query';
import { useSetAtom } from 'jotai';

/**
 * Replace the current user's API key (`POST /users/me/apiKey`). The new key is
 * returned only here, so `reset()` the mutation once it has been shown.
 */
export function useRegenerateApiKey() {
  const setUser = useSetAtom(userAtom);

  return useMutation({
    mutationFn: () => fetchWrapper.post<RegeneratedApiKey>(api.myApiKey, {}),
    gcTime: 0,
    onSuccess: ({ apiKey }) => {
      // PDF uploads authenticate with the key, so the session switches to the new one.
      setUser((user) => (user ? { ...user, apiKey } : user));
    },
  });
}
